import axios from "./axios/config";

export const getMonitoringQueue = async (query) => {
  let url = `flag/monitoring-queue/paginated?${query}`;

  const res = await axios.get(url);
  const data = res.data;
  return { data: data.data, totalCount: data.elements };
};
